import { CohortSummaryAttributeResult, DomainType } from '@verantos-dev/types-cohorts';
import { ConceptGroup } from '@verantos-dev/types-concepts';

import { ConceptGroupStats } from '../hooks/useCustomConceptSelection';

export const mapConceptGroupsToStats = (
  dialogConceptGroups: ConceptGroup[],
  domain: DomainType
): ConceptGroupStats[] => {
  return (
    dialogConceptGroups?.map((group: ConceptGroup) => ({
      id: `${domain}-${group.conceptGroupId}`,
      name: group.conceptGroupName,
      count: group.conceptCount || 0,
      percentage: 0,
    })) || []
  );
};

export const sortConceptGroupsByCount = (
  conceptGroupsStats: ConceptGroupStats[]
): ConceptGroupStats[] => {
  return [...conceptGroupsStats].sort((a, b) => b.count - a.count);
};

export const findMatchingConceptGroups = (
  chartData: CohortSummaryAttributeResult[],
  availableStats: ConceptGroupStats[]
): ConceptGroupStats[] => {
  const matchingStats: ConceptGroupStats[] = [];

  chartData.forEach((chartItem) => {
    const matchingStat = availableStats.find(
      (stat) =>
        stat.name === chartItem.attributeName ||
        stat.name.toLowerCase().trim() === chartItem.attributeName.toLowerCase().trim()
    );

    if (matchingStat) {
      matchingStats.push(matchingStat);
    }
  });

  return matchingStats;
};
